/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsTenant extends models.FilterOptionsBase {
    getFixupPrototypeFunction() { return FilterOptionsTenant.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsTenant>): FilterOptionsTenant {
        let obj = Object.assign(new FilterOptionsTenant(), model);
        FilterOptionsTenant.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsTenant>): FilterOptionsTenant {
        if (!model) return null;
        return FilterOptionsTenant.newInstance(<FilterOptionsTenant> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsTenant) {
        if (!obj) return;

        models.FilterOptionsTenant.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsTenant): boolean {
        if (models.FilterOptionsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FilterOptionsTenant.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.cloud_providers) {
            for (let val of this.cloud_providers) {
                models.FilterOptionsCloudProvider.fixupPrototype(val);
            }
        }
        if (this.integrated_tool_providers) {
            for (let val of this.integrated_tool_providers) {
                models.FilterOptionsIntegratedToolProvider.fixupPrototype(val);
            }
        }
        if (this.ai_providers) {
            for (let val of this.ai_providers) {
                models.FilterOptionsForSaasAiServices.fixupPrototype(val);
            }
        }
        if (this.data_service_providers) {
            for (let val of this.data_service_providers) {
                models.FilterOptionsForSaasDataServices.fixupPrototype(val);
            }
        }
        if (this.other_service_providers) {
            for (let val of this.other_service_providers) {
                models.FilterOptionsForSaasOtherServices.fixupPrototype(val);
            }
        }
        if (this.dimension_cost_centers) {
            for (let val of this.dimension_cost_centers) {
                models.FilterOptionsDimensionCostCenterAccount.fixupPrototype(val);
            }
        }
        if (this.container_providers) {
            for (let val of this.container_providers) {
                models.FilterOptionsContainerProviders.fixupPrototype(val);
            }
        }
        if (this.platform_providers) {
            for (let val of this.platform_providers) {
                models.FilterOptionsPlatformProvider.fixupPrototype(val);
            }
        }
    }

    cloud_providers: Array<models.FilterOptionsCloudProvider>;

    integrated_tool_providers: Array<models.FilterOptionsIntegratedToolProvider>;

    ai_providers: Array<models.FilterOptionsForSaasAiServices>;

    data_service_providers: Array<models.FilterOptionsForSaasDataServices>;

    other_service_providers: Array<models.FilterOptionsForSaasOtherServices>;

    dimension_cost_centers: Array<models.FilterOptionsDimensionCostCenterAccount>;

    container_providers: Array<models.FilterOptionsContainerProviders>;

    platform_providers: Array<models.FilterOptionsPlatformProvider>;

}
